
import { css } from 'lit';
export default css`
p + p {
  margin-top: 1.75rem;
  margin-bottom: 0px;
}@media (min-width: 1024px) {p + p {
    margin-top: 2rem;
  }p + p {
    margin-bottom: 0px;
  }
}

p + ul.default, p + ol.default, p + ul.light, p + ol.light, p + ol.lower-alpha, p + ol.lower-alpha-light {
  margin-top: 0px;
}

figure {
  margin: 0;
  overflow: hidden;
}
`;